export enum EnvironmentTermsPlacement {
  LastPage = 'lastPage',
  Footer = 'footer',
}
